import { css } from '@emotion/core';
import styled from '@emotion/styled';
import React from 'react';
import { BaseLink } from 'views/components/atoms/BaseLink';
import { Typography } from 'views/components/atoms/Typography';
import { Color, FontSize, MAX_WIDTH } from 'views/constants';

type FooterLinkType = {
  text: string;
  href: string;
};

interface FooterProps {
  links: FooterLinkType[];
}

const StyledFooter = styled.footer`
  background-color: ${Color.C5};
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: space-evenly;
`;

const ContentWrapper = styled.div`
  max-width: ${MAX_WIDTH};
  padding: 10px;
`;

const styles = css`
  margin: 6px;
`;

export const Footer: React.FC<FooterProps> = ({ links }) => (
  <StyledFooter>
    <ContentWrapper>
      {links.map((link) => (
        <React.Fragment key={link.href}>
          <BaseLink to={link.href} noDecoration style={styles} anotherTab>
            <Typography color={Color.C12} size={FontSize.XS}>
              {link.text}
            </Typography>
          </BaseLink>
        </React.Fragment>
      ))}
    </ContentWrapper>
  </StyledFooter>
);
